import React from 'react';
import Layout from '../../components/Layout'; // Importando o Layout
import { PageProps } from '../../App'; // Importando a interface PageProps
import { Link } from 'react-router-dom';

// Componente da página de IA com tipagem correta
const IAPage: React.FC<PageProps> = ({ darkMode, toggleDarkMode }) => {
  return (
    <Layout darkMode={darkMode} toggleDarkMode={toggleDarkMode}>
      <div className="bg-white dark:bg-gray-900">
        {/* Hero Section */}
        <div className="relative bg-gradient-to-r from-lupa-orange to-lupa-yellow overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-r from-lupa-purple-dark/70 to-lupa-purple/30 z-10"></div>
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 relative z-20">
            <div className="text-center">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight font-heading">
                Inteligência Artificial
              </h1>
              <p className="mt-6 text-xl text-white/90 max-w-3xl mx-auto">
                Transforme seus dados em insights acionáveis com soluções avançadas de IA que impulsionam a inovação, otimizam processos e criam vantagens competitivas sustentáveis para o seu negócio.
              </p>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320" className="w-full h-auto">
              <path fill="#ffffff" fillOpacity="1" d="M0,96L48,112C96,128,192,160,288,160C384,160,480,128,576,122.7C672,117,768,139,864,149.3C960,160,1056,160,1152,138.7C1248,117,1344,75,1392,53.3L1440,32L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
            </svg>
          </div>
        </div>

        {/* Conteúdo Principal */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-6">Potencialize seu negócio com IA</h2>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                A Inteligência Artificial (IA) está revolucionando a forma como as empresas operam, permitindo automação inteligente, 
                insights preditivos e tomada de decisões baseada em dados em uma escala sem precedentes. Diferente da automação tradicional, 
                a IA não apenas executa tarefas repetitivas, mas aprende, adapta-se e evolui com o tempo, identificando padrões complexos 
                que seriam impossíveis de detectar manualmente.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Na era digital atual, empresas que não adotam IA estão ficando para trás. Segundo pesquisas recentes, organizações que 
                implementam soluções de IA experimentam um aumento médio de 40% em produtividade e redução de 20% em custos operacionais. 
                A capacidade de processar enormes volumes de dados em tempo real permite antecipar tendências de mercado, personalizar 
                experiências de cliente e otimizar cadeias de suprimentos com precisão inédita.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Na Lupa Data, desenvolvemos soluções de IA personalizadas que ajudam sua empresa a extrair valor real dos seus dados, 
                automatizar processos complexos e criar vantagens competitivas sustentáveis. Nossa abordagem combina expertise técnica 
                com profundo conhecimento de negócios, garantindo que nossas soluções não sejam apenas tecnicamente avançadas, mas 
                também perfeitamente alinhadas aos seus objetivos estratégicos e operacionais.
              </p>
              <p className="text-gray-700 dark:text-gray-300 mb-4">
                Nosso diferencial está na capacidade de traduzir conceitos complexos de IA em soluções práticas e acessíveis, 
                democratizando o acesso a tecnologias avançadas para empresas de todos os portes. Trabalhamos em estreita colaboração 
                com sua equipe para garantir uma implementação suave e uma adoção eficaz, maximizando o retorno sobre o investimento.
              </p>
              <div className="mt-8">
                <Link to="/contato" className="btn-primary">
                  Fale com um especialista
                </Link>
              </div>
            </div>
            <div className="bg-gray-100 dark:bg-gray-800 p-8 rounded-xl shadow-lg">
              <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Aplicações de IA</h3>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <span className="text-gray-700 dark:text-gray-300 font-medium">Análise preditiva e forecasting</span>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Antecipe tendências de mercado, demanda de produtos e comportamento de consumidores com precisão de até 95%, 
                      permitindo planejamento estratégico baseado em dados concretos em vez de intuição.
                    </p>
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <span className="text-gray-700 dark:text-gray-300 font-medium">Detecção de anomalias e fraudes</span>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Identifique padrões suspeitos em tempo real com sistemas que monitoram milhões de transações simultaneamente, 
                      reduzindo perdas financeiras e protegendo a reputação da sua empresa.
                    </p>
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <span className="text-gray-700 dark:text-gray-300 font-medium">Segmentação e personalização de clientes</span>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Crie experiências hiperpersonalizadas analisando centenas de variáveis comportamentais, aumentando a satisfação 
                      do cliente e a taxa de conversão em até 30%.
                    </p>
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <span className="text-gray-700 dark:text-gray-300 font-medium">Processamento de linguagem natural (NLP)</span>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Extraia insights valiosos de textos não estruturados como e-mails, redes sociais e documentos, transformando 
                      dados qualitativos em informações quantificáveis e acionáveis.
                    </p>
                  </div>
                </li>
                <li className="flex items-start">
                  <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                  </svg>
                  <div>
                    <span className="text-gray-700 dark:text-gray-300 font-medium">Visão computacional e reconhecimento de imagens</span>
                    <p className="text-sm text-gray-600 dark:text-gray-400 mt-1">
                      Automatize inspeções visuais com precisão superior à humana, identificando defeitos microscópicos em linhas de 
                      produção ou analisando imagens médicas para diagnósticos precoces.
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          {/* Nosso Processo */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Nosso Processo de IA</h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-white">1</span>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Avaliação de Dados</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Analisamos seus dados existentes e identificamos oportunidades para aplicações de IA. Esta fase inclui auditoria 
                  completa de fontes de dados, avaliação de qualidade e completude, e identificação de lacunas críticas que precisam 
                  ser preenchidas.
                </p>
                <p className="text-gray-700 dark:text-gray-300 mt-2">
                  Utilizamos técnicas avançadas de análise exploratória para descobrir padrões ocultos e correlações que podem ser 
                  exploradas por algoritmos de IA, garantindo que construímos sobre uma base sólida de dados relevantes e confiáveis.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-white">2</span>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Desenvolvimento de Modelos</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Criamos modelos de IA personalizados para resolver seus desafios específicos de negócio. Nossa equipe de cientistas 
                  de dados e engenheiros de machine learning desenvolve, treina e refina algoritmos utilizando as mais recentes técnicas 
                  e frameworks.
                </p>
                <p className="text-gray-700 dark:text-gray-300 mt-2">
                  Testamos múltiplas abordagens algorítmicas para encontrar a solução ideal, equilibrando precisão, velocidade e 
                  interpretabilidade. Cada modelo passa por rigorosos testes de validação cruzada para garantir desempenho consistente 
                  em cenários reais.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-white">3</span>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Implementação</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Integramos as soluções de IA em seus sistemas existentes com mínima interrupção. Nossa abordagem de implementação 
                  gradual permite que você comece a obter valor rapidamente, enquanto minimiza riscos operacionais.
                </p>
                <p className="text-gray-700 dark:text-gray-300 mt-2">
                  Desenvolvemos APIs personalizadas e interfaces intuitivas que permitem que suas equipes interajam facilmente com os 
                  modelos de IA. Fornecemos treinamento abrangente para garantir adoção efetiva e maximizar o retorno sobre o investimento.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg text-center">
                <div className="w-16 h-16 mx-auto bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <span className="text-2xl font-bold text-white">4</span>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Monitoramento Contínuo</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Garantimos que seus modelos de IA continuem performando e evoluindo com seu negócio. Implementamos sistemas de 
                  monitoramento em tempo real que detectam desvios de desempenho e alertam sobre a necessidade de ajustes.
                </p>
                <p className="text-gray-700 dark:text-gray-300 mt-2">
                  Realizamos atualizações periódicas para incorporar novos dados e refinar os algoritmos, mantendo sua solução de IA 
                  na vanguarda tecnológica. Nossa equipe de suporte especializado está sempre disponível para resolver questões e 
                  implementar melhorias contínuas.
                </p>
              </div>
            </div>
          </div>

          {/* Casos de Uso */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Casos de Uso</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                  <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Previsão de Demanda</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Modelos de IA que preveem com precisão a demanda futura, otimizando estoques e reduzindo custos. Nossos algoritmos 
                    analisam padrões históricos, sazonalidades, tendências de mercado e até mesmo fatores externos como clima e eventos 
                    sociais para gerar previsões com precisão superior a 90%.
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Um varejista nacional implementou nossa solução de previsão de demanda e reduziu o excesso de estoque em 35%, 
                    diminuiu as rupturas em 42% e aumentou as margens de lucro em 15% no primeiro ano. A capacidade de antecipar 
                    picos de demanda permitiu um planejamento logístico mais eficiente e negociações mais vantajosas com fornecedores.
                  </p>
                  <Link to="/solucoes/lupa-cast" className="text-lupa-orange font-medium hover:underline">Conheça o Lupa Cast →</Link>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                  <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M17 8h2a2 2 0 012 2v6a2 2 0 01-2 2h-2v4l-4-4H9a1.994 1.994 0 01-1.414-.586m0 0L11 14h4a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2v4l.586-.586z" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Análise de Sentimento</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Entenda o sentimento dos clientes através da análise de comentários, reviews e interações sociais. Nossos modelos 
                    de NLP vão além da simples classificação positivo/negativo, identificando emoções específicas, tópicos recorrentes 
                    e tendências emergentes em tempo real.
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Uma empresa de telecomunicações utilizou nossa solução para analisar mais de 500.000 interações mensais de clientes 
                    em diversos canais. Isso permitiu identificar rapidamente problemas emergentes, melhorar produtos com base no feedback 
                    e aumentar a satisfação do cliente em 28%, reduzindo o churn em 17%.
                  </p>
                  <Link to="/solucoes/lia" className="text-lupa-orange font-medium hover:underline">Conheça o LIA →</Link>
                </div>
              </div>
              <div className="bg-white dark:bg-gray-800 rounded-xl shadow-lg overflow-hidden">
                <div className="h-48 bg-gradient-to-r from-lupa-orange to-lupa-yellow flex items-center justify-center">
                  <svg className="h-24 w-24 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                  </svg>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Detecção de Fraudes</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Identifique padrões suspeitos e previna fraudes antes que causem prejuízos à sua empresa. Nossos sistemas de IA 
                    monitoram transações em tempo real, utilizando redes neurais e aprendizado profundo para detectar anomalias sutis 
                    que escapariam aos métodos tradicionais.
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Uma instituição financeira implementou nossa solução de detecção de fraudes e conseguiu reduzir perdas em 78%, 
                    diminuir falsos positivos em 63% e aumentar a eficiência operacional da equipe de segurança. O sistema analisa 
                    mais de 10.000 transações por segundo, identificando padrões suspeitos com precisão superior a 99%.
                  </p>
                  <Link to="/contato" className="text-lupa-orange font-medium hover:underline">Solicite uma demonstração →</Link>
                </div>
              </div>
            </div>
          </div>

          {/* Nossa Solução: LIA */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Conheça o LIA: Nossa Solução de IA Conversacional</h2>
            <div className="bg-gradient-to-r from-lupa-purple/10 to-lupa-orange/10 dark:from-lupa-purple/20 dark:to-lupa-orange/20 p-8 rounded-xl shadow-lg">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-lupa-purple dark:text-white mb-4">Democratizando o Acesso aos Dados</h3>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    O <Link to="/solucoes/lia" className="text-lupa-orange hover:underline">LIA (Lupa Inteligência Artificial)</Link> é nossa solução 
                    de IA conversacional que permite que qualquer pessoa na sua organização interaja com dados complexos através de linguagem natural. 
                    Não é mais necessário conhecimento técnico ou habilidades em SQL para obter insights valiosos.
                  </p>
                  <p className="text-gray-700 dark:text-gray-300 mb-4">
                    Com o LIA, seus colaboradores podem simplesmente perguntar: "Qual foi o produto mais vendido no último trimestre?" ou 
                    "Quais regiões tiveram queda nas vendas comparado ao ano anterior?" e receber respostas instantâneas, precisas e 
                    contextualizadas, acompanhadas de visualizações intuitivas.
                  </p>
                  <ul className="space-y-3 mt-6">
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300">Reduz o tempo de análise de dados em até 80%</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300">Elimina a dependência de equipes técnicas para relatórios</span>
                    </li>
                    <li className="flex items-start">
                      <svg className="h-6 w-6 text-lupa-orange mt-0.5 mr-2 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                      </svg>
                      <span className="text-gray-700 dark:text-gray-300">Acelera a tomada de decisões com insights em tempo real</span>
                    </li>
                  </ul>
                  <div className="mt-8">
                    <Link to="/solucoes/lia" className="btn-primary">
                      Conheça o LIA
                    </Link>
                  </div>
                </div>
                <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                  <div className="bg-gray-100 dark:bg-gray-700 rounded-lg p-4 mb-4">
                    <p className="text-gray-700 dark:text-gray-300 italic">
                      "O LIA transformou completamente nossa cultura de dados. Agora, todos os departamentos têm acesso às informações 
                      que precisam, quando precisam, sem depender da equipe de TI. Isso acelerou nosso processo de tomada de decisão 
                      e nos permitiu responder muito mais rapidamente às mudanças do mercado."
                    </p>
                    <p className="text-gray-600 dark:text-gray-400 text-sm mt-2">
                      — Diretor de Tecnologia, empresa do setor de varejo
                    </p>
                  </div>
                  <div className="flex items-center justify-center">
                    <Link to="/solucoes/lia" className="text-lupa-orange font-medium hover:underline flex items-center">
                      Ver demonstração do LIA
                      <svg className="ml-2 h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Benefícios da IA */}
          <div className="mt-20">
            <h2 className="text-3xl font-bold text-lupa-purple dark:text-white mb-8 text-center">Benefícios Transformadores da IA</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Aumento de Eficiência</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Automatize tarefas repetitivas e processos complexos, liberando seus colaboradores para atividades de maior valor. 
                  Nossos clientes relatam ganhos de produtividade de 30% a 70% após a implementação de soluções de IA.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Redução de Custos</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Otimize operações, minimize desperdícios e reduza erros humanos. A implementação de IA pode reduzir custos operacionais 
                  em até 25% e aumentar a precisão de processos críticos para mais de 99%.
                </p>
              </div>
              <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-lg">
                <div className="w-16 h-16 bg-lupa-orange rounded-full flex items-center justify-center mb-4">
                  <svg className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-xl font-bold text-lupa-purple dark:text-white mb-2">Vantagem Competitiva</h3>
                <p className="text-gray-700 dark:text-gray-300">
                  Antecipe-se às tendências de mercado, personalize experiências de cliente e inove mais rapidamente que seus concorrentes. 
                  A IA permite que você tome decisões mais rápidas e mais precisas, criando uma vantagem competitiva sustentável.
                </p>
              </div>
            </div>
          </div>

          {/* CTA */}
          <div className="mt-20 bg-gradient-to-r from-lupa-orange to-lupa-yellow rounded-xl p-8 md:p-12 shadow-xl">
            <div className="md:flex md:items-center md:justify-between">
              <div className="md:w-2/3">
                <h2 className="text-3xl font-bold text-white mb-4">Pronto para transformar seu negócio com IA?</h2>
                <p className="text-white/90 text-lg mb-6 md:mb-0">
                  Descubra como a Lupa Data pode ajudar sua empresa a implementar soluções de IA que geram resultados reais. 
                  Nossa equipe de especialistas está pronta para desenvolver uma estratégia personalizada que atenda às suas 
                  necessidades específicas e impulsione seu crescimento.
                </p>
              </div>
              <div className="md:w-1/3 text-center">
                <Link to="/contato" className="inline-block bg-white text-lupa-orange font-bold py-3 px-8 rounded-lg shadow-md hover:shadow-lg transition-all duration-300">
                  Agende uma demonstração
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default IAPage;
                          